import script from "./delete_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./delete_btn.vue?vue&type=script&setup=true&lang=js"

import "./delete_btn.vue?vue&type=style&index=0&id=ae703640&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae703640"]])

export default __exports__